import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ComponentBase } from 'app/core/componentBase';
import { TilledAlert } from 'app/core/models/tilled-alert';
import { AlertService } from 'app/core/services/alert.service';
import { PricingTemplateAppService } from 'app/core/services/pricing-template.app.service';
import { takeUntil } from 'rxjs';
import { FormCardComponent } from '../../cards/form-cards/form-card.component';
import { TilledInputComponent } from '../../form-fields/tilled-input/tilled-input.component';

@Component({
  selector: 'editable-pricing-template-nickname-dialog',
  templateUrl: './editable-pricing-template-nickname-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatProgressBarModule,
    CommonModule,
    FormCardComponent,
    ReactiveFormsModule,
    MatIconModule,
    CommonModule,
    TilledInputComponent,
  ],
})
export class EditablePricingTemplateNicknameDialogComponent extends ComponentBase implements OnInit {
  @Input() nickname: string;
  @Input() pricingTemplateId: string;
  @Input() accountId: string;
  public editStatus: boolean = false;
  public nameInput: string;
  public loading: boolean = false;
  public errorMessage: string = 'Test Error Message';
  public editPricingTemplateNickNameForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _pricingTemplateAppService: PricingTemplateAppService,
    private _alertService: AlertService,
    private _formBuilder: FormBuilder,
    private _dialogRef: MatDialogRef<EditablePricingTemplateNicknameDialogComponent>,
  ) {
    super();
    this.nickname = this._data.nickname;
    this.pricingTemplateId = this._data.pricingTemplateId;
    this.accountId = this._data.accountId;
  }

  ngOnInit(): void {
    this.editPricingTemplateNickNameForm = this._formBuilder.group({
      nameInput: [this.nickname || ''],
    });
  }

  public closeDialog(): void {
    this.nameInput = this.nickname;
    this._dialogRef.close();
  }

  saveEditPricingTemplateNickName(): void {
    const nameInputValue = this.editPricingTemplateNickNameForm.get('nameInput')?.value?.trim();
    if (!nameInputValue || nameInputValue === this.nickname?.trim()) {
      return;
    }

    this.loading = true;
    this._pricingTemplateAppService
      .internalUpdatePricingTemplate(this.pricingTemplateId, this.accountId, nameInputValue)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.nickname = res.name;
          this.editPricingTemplateNickNameForm.get('nameInput')?.setValue(res.name);
          this.editStatus = false;
          this.loading = false;
          this._dialogRef.close(res.name);
        },
        error: (err: Error) => {
          this.editPricingTemplateNickNameForm.get('nameInput')?.setValue(this.nickname);
          this.loading = false;
          this.errorMessage = err.message;
          const alert: TilledAlert = {
            message: this.errorMessage,
            title: 'Error',
            type: 'error',
          };
          this._alertService.showAlert(alert);
        },
      });
  }
}
